(() => {

  const OPTIN_KEY = "funnel_optin_submitted_v1";

  const hasOptedIn = () => {
    try { return localStorage.getItem(OPTIN_KEY) === "1"; } catch (e) { return false; }
  };

  const setOptedIn = () => {
    try { localStorage.setItem(OPTIN_KEY, "1"); } catch (e) {}
  };

  const applyOptInState = () => {
    const btn = document.querySelector("[data-funnel-optin]");
    const thanks = document.querySelector("[data-funnel-thanks]");
    if (!btn || !thanks) return;

    if (hasOptedIn()) {
      btn.hidden = true;
      thanks.hidden = false;
    } else {
      btn.hidden = false;
      thanks.hidden = true;
    }
  };

  const NAMED = {
  "black": "#111111",
  "deep_black": "#0a0a0a",
  "tnf_black": "#0d0d0d",
  "white": "#ffffff",
  "bright_white": "#ffffff",
  "natural": "#f4efe6",
  "light_ivory": "#f6f1e6",
  "cream": "#f5efe2",
  "sand": "#d8c7a1",
  "wheat": "#c9a86a",
  "warm_quartz": "#d9b8b0",
  "desert_rose_heather": "#c78f8f",

  "gray": "#8b8b8b",
  "light_grey": "#d3d3d3",
  "ultra_light_grey": "#e8e8e8",
  "grey_frost": "#bfc3c7",
  "black_frost": "#2f2f2f",
  "asphalt_gry": "#555555",
  "charcoal": "#36454f",
  "anthracite": "#303030",
  "storm_grey": "#6e7072",
  "quiet_shade_grey_heather": "#a6a8ab",
  "soapstone": "#cfcac2",

  "navy": "#1a2a44",
  "true_navy": "#1b2b50",
  "nautical_navy": "#1e3a5f",
  "night_navy": "#1c2f4a",
  "colnavi": "#1a2a44",
  "navy_heather": "#3a4b63",
  "copen_blue": "#4f6d8c",
  "indochine_blue": "#2c5d86",
  "hd_eucalyptus_blue": "#4a7f8a",
  "shady_blue": "#4f6f8f",
  "airy_blue_heather": "#a7bfd8",
  "gameroyal": "#4169e1",

  "alouette": "#5b7fa6",
  "brite_lime": "#a4d233",
  "balsam_green": "#2f5e3b",
  "clay_green": "#4f6b4a",
  "loden": "#4a5d23",
  "dark_green": "#0b3d2e",
  "light_denim": "#6fa3d2",
  "red": "#c8102e"
};


const normKey = (s) =>
  (s || "")
    .toString()
    .trim()
    .toLowerCase()

    .replace(/[\/]+/g, " ")

    .replace(/[^a-z0-9\s]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\s/g, "_");


const NAMED_ALIASES = (() => {
  const m = { ...NAMED };
  for (const [k, v] of Object.entries(NAMED)) {
    m[k.replace(/_/g, " ")] = v;  
    m[k.replace(/_/g, "-")] = v;      
  }
  return m;
})();

const pickColor = (name) => {
  const raw = (name || "").toString().trim();
  const k = normKey(raw);


  if (NAMED[k]) return NAMED[k];


  const spaceKey = k.replace(/_/g, " ");
  if (NAMED_ALIASES[spaceKey]) return NAMED_ALIASES[spaceKey];

  const parts = k.split("_").filter(Boolean);
  for (let len = 1; len <= parts.length; len++) {
    const tail = parts.slice(parts.length - len).join("_");
    if (NAMED[tail]) return NAMED[tail];
  }

  for (const key of Object.keys(NAMED)) {
    if (k.includes(key)) return NAMED[key];
  }


  return hashToHsl(k);
};



  const isLightColor = (cssColor) => {
    const c = (cssColor || "").trim();

    if (c.startsWith("#") && c.length === 7) {
      const r = parseInt(c.slice(1, 3), 16);
      const g = parseInt(c.slice(3, 5), 16);
      const b = parseInt(c.slice(5, 7), 16);
      const y = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
      return y > 0.82;
    }
    return false;
  };


  const initSwatches = (root = document) => {
    const swatches = root.querySelectorAll("[data-swatch-list] .fSwatch[data-color-name]");
    swatches.forEach((el) => {
      const name = el.getAttribute("data-color-name") || "";
      const c = pickColor(name);
      el.style.setProperty("--swatch-color", c);
      el.setAttribute("data-swatch-hex", "1");
      if (isLightColor(c)) el.classList.add("is-light");
    });
  };

const initOptIn = () => {
  const btn = document.querySelector("[data-funnel-optin]");
  const modal = document.querySelector("[data-optin-modal]");
  if (!btn || !modal) return;

    // If already opted-in, hide CTA + prevent reopening modal
  applyOptInState();
  if (hasOptedIn()) return;

  const closeEls = modal.querySelectorAll("[data-optin-close]");
  const form = modal.querySelector("[data-optin-form]");
  let lastFocus = null;

  const lockBody = (on) => {
    document.documentElement.style.overflow = on ? "hidden" : "";
    document.body.style.overflow = on ? "hidden" : "";
  };

  const open = () => {
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    lockBody(true);

    // focus first input
    const first = modal.querySelector("input, button, select, textarea");
    if (first) first.focus();
  };

  const close = () => {
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    lockBody(false);

    if (form) form.reset();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  btn.addEventListener("click", () => {
    btn.classList.add("is-clicked");
    btn.blur();
    open();
  });

  closeEls.forEach((el) => el.addEventListener("click", close));

  // Esc closes
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) close();
  });

  // Submit stub (you'll replace later)
  if (form) {


form.addEventListener("submit", async (e) => {
  e.preventDefault();

  const fd = new FormData(form);
  const payload = {
    name: (fd.get("name") || "").toString().trim(),
    email: (fd.get("email") || "").toString().trim(),
    webstore: (fd.get("webstore") || "").toString().trim(),
    source: "funnel_optin",
    page_url: window.location.href
  };

  if (!payload.name || !payload.email || !payload.webstore) {
    alert("Please fill out all fields.");
    return;
  }

  const submitBtn =
    form.querySelector("[data-optin-submit]") || form.querySelector('button[type="submit"]');
  const oldText = submitBtn ? submitBtn.textContent : "";

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = "Sending…";
  }

  try {
    // Send as x-www-form-urlencoded WITHOUT setting headers (prevents CORS preflight)
    const body = new URLSearchParams(payload).toString();

    await fetch("https://sparkling-cake-5603.inkdstores.workers.dev/optin", {
      
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    setOptedIn();
    applyOptInState();

    // If fetch resolves, treat as success (Zapier likely got it)
    if (submitBtn) submitBtn.textContent = "Sent ✓";
    setTimeout(() => close(), 650);
  } catch (err) {
    console.error("[optin] submit failed", err);
    alert("Couldn’t submit right now. Please try again.");
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = oldText || "Submit";
    }
  }
});



  }
};


  const initQuickView = () => {
    const modal = document.querySelector("[data-fqv-modal]");
    if (!modal) return;

    const body = modal.querySelector("[data-fqv-body]");
    const closeEls = modal.querySelectorAll("[data-fqv-close]");
    let lastFocus = null;

    const lockBody = (on) => {
      document.documentElement.style.overflow = on ? "hidden" : "";
      document.body.style.overflow = on ? "hidden" : "";
    };

    const wireModalContent = () => {

      initSwatches(body);

      const mainImg = body.querySelector("[data-fqv-main]");
      body.querySelectorAll("[data-fqv-thumb]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const src = btn.getAttribute("data-src");
          if (mainImg && src) {
            mainImg.setAttribute("src", src);
          }
        });
      });
    };

    const openModal = async (url) => {
      lastFocus = document.activeElement;

      body.innerHTML = `<div class="fModal__loading">Loading…</div>`;
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      lockBody(true);

      try {
        const res = await fetch(url, { credentials: "same-origin" });
        const html = await res.text();
        body.innerHTML = html;

        wireModalContent();


        const closeBtn = modal.querySelector(".fModal__close");
        if (closeBtn) closeBtn.focus();
      } catch (e) {
        body.innerHTML = `<div class="fModal__loading">Failed to load product.</div>`;
      }
    };

    const closeModal = () => {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      lockBody(false);
      body.innerHTML = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };


    closeEls.forEach((el) => el.addEventListener("click", closeModal));
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.hidden) closeModal();
    });

    document.addEventListener("click", (e) => {
      const a = e.target.closest("[data-fqv-open]");
      if (!a) return;

      e.preventDefault();
      const url = a.getAttribute("data-fqv-url");
      if (!url) return;

      openModal(url);
    });
  };

  const boot = () => {
    initSwatches(document);
    applyOptInState();
    initOptIn();
    initQuickView();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();